import { TOtpStore } from '~/store/otp-verification/types.ts';

export const otpVerificationState: TOtpStore = {
  phone: '',
  otp: '',
  isVerified: false,
  verificationToken: '',

  loading: false,
  error: null,
  status: '',
};
